import ReactOnRails from 'react-on-rails/client';
import BlogPost from '../../bundles/Blog/components/BlogPost.client.jsx';

ReactOnRails.register({BlogPost});